import { API } from "@services/http.service";

/**
 * Yarışma motoru kullanıcı uçları (connection-competition-service /play/competitions).
 * Kimlik her zaman token'dan alınır; isteklere kullanıcı bilgisi konmaz.
 */
const BASE = "/competition/play/competitions";

export const getMyCompetitions = () => API.get(BASE);

export const getCompetition = (id) => API.get(`${BASE}/${id}`);

export const acceptDisclaimer = (id) => API.post(`${BASE}/${id}/disclaimer`);

/** Bugünün soru durumu. Sıradaki soru açılmadıysa AÇAR ve 90 saniyelik süreyi başlatır. */
export const getQuestion = (id) => API.get(`${BASE}/${id}/question`);

export const sendAnswer = (id, { gameId, choiceId, textAnswer }) =>
  API.post(`${BASE}/${id}/answer`, { gameId, choiceId, textAnswer });

const listParams = ({ page = 0, size = 20, date, name }) => {
  const params = new URLSearchParams({ page, size });
  if (date) params.append("date", date);
  if (name && name.trim()) params.append("name", name.trim());
  return params.toString();
};

export const getWinners = (id, filters) =>
  API.get(`${BASE}/${id}/winners?${listParams(filters)}`);

export const getCorrectResponders = (id, filters) =>
  API.get(`${BASE}/${id}/correct-responders?${listParams(filters)}`);
